import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRequest } from "../../api/utils/useRequest";
import { AccountAPIs } from "../../api/APIs";
import { LoadingButton } from "@mui/lab";
import BottomFullWidthButtonContainer from "../../components/shared/BottomFullWidthButtonContainer";
import { useSnackBar } from "../../context/SnackBarContext";
import moment from "moment-jalaali";
import { SetBirthDateBottomSheet } from "../../components/profile/SetBirthDateBottomSheet";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { CancelOutlined } from "@mui/icons-material";
import { isNationalIdValid } from "../../utils/validations";
import { removeNonNumeric } from "../../utils/Utils";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = location.state.mobile;
  const list = location.state.list;
  const dateInput = useRef(null);
  const openSnack = useSnackBar();
  const [listValues, setListValues] = useState(
    list.map((item) => {
      return { name: item.name, value: "" };
    })
  );

  const [openDrawer, setOpenDrawer] = useState(false);

  const { loading, apiCall: finishForgotPassword } = useRequest(
    AccountAPIs.finishForgotPassword
  );

  const handleSubmit = () => {
    finishForgotPassword({
      data: { mobile: mobile, list: listValues },
      onSuccess: () => {
        navigate("/auth/set-password/set", { state: { mobile } });
      },
    });
  };

  const isFormValid = () => {
    return listValues.every((item) => {
      if (item.name === "nationalId") {
        return isNationalIdValid(item.value);
      } else {
        return Boolean(item.value);
      }
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            فراموشی رمز عبور
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        {list.map((item) => {
          if (item.name === "nationalId") {
            const nationalId = listValues.find(
              (valuesItem) => valuesItem.name === item.name
            ).value;

            return (
              <>
                <Typography variant="body2" color="grey.2">
                  {item.label}
                </Typography>
                <TextField
                  name="nationalId"
                  inputProps={{
                    inputMode: "numeric",
                  }}
                  error={
                    nationalId.length === 10 && !isNationalIdValid(nationalId)
                  }
                  helperText={
                    nationalId.length === 10 &&
                    !isNationalIdValid(nationalId) &&
                    "کد ملی معتبر نیست."
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {nationalId.length > 0 && (
                          <IconButton
                            onClick={() => {
                              setListValues((prev) =>
                                prev.map((prevItem) => {
                                  if (prevItem.name === "nationalId") {
                                    return {
                                      ...prevItem,
                                      value: "",
                                    };
                                  } else {
                                    return prevItem;
                                  }
                                })
                              );
                            }}
                          >
                            <CancelOutlined sx={{ fontSize: 20 }} />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                  value={nationalId}
                  onChange={(event) =>
                    setListValues((prev) =>
                      prev.map((prevItem) => {
                        if (prevItem.name === "nationalId") {
                          if (event.target.value === null) {
                            return {
                              ...prevItem,
                              value: "",
                            };
                          } else if (event.target.value.length < 11) {
                            return {
                              ...prevItem,
                              value: removeNonNumeric(event.target.value),
                            };
                          } else {
                            return prevItem;
                          }
                        } else {
                          return prevItem;
                        }
                      })
                    )
                  }
                  sx={{ mt: "8px" }}
                  fullWidth
                />
              </>
            );
          }

          if (item.name === "birthDate") {
            return (
              <>
                <Typography mt={2} variant="body2" color="grey.2">
                  {item.label}
                </Typography>
                <TextField
                  name="birthDate"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {mobile.length > 0 && (
                          <IconButton>
                            <DateRangeIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                  ref={dateInput}
                  onFocus={(event) => {
                    event.target.blur();
                    setOpenDrawer(true);
                  }}
                  value={
                    Boolean(
                      listValues.find(
                        (valuesItem) => valuesItem.name === item.name
                      ).value
                    )
                      ? moment(
                          listValues.find(
                            (valuesItem) => valuesItem.name === item.name
                          ).value
                        ).format("jYYYY/jMM/jDD")
                      : ""
                  }
                  sx={{ mt: "8px" }}
                  fullWidth
                />
                <SetBirthDateBottomSheet
                  open={openDrawer}
                  setOpen={setOpenDrawer}
                  birthDate={
                    listValues.find(
                      (valuesItem) => valuesItem.name === item.name
                    ).value
                  }
                  setBirthDate={(date) =>
                    setListValues((prev) =>
                      prev.map((item) => {
                        if (item.name === "birthDate") {
                          return {
                            ...item,
                            value: date,
                          };
                        } else {
                          return item;
                        }
                      })
                    )
                  }
                />
              </>
            );
          }
        })}
        <BottomFullWidthButtonContainer>
          <LoadingButton
            loading={loading}
            onClick={handleSubmit}
            disabled={!isFormValid()}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            بررسی
          </LoadingButton>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default ForgotPasswordPage;
